<template>
    <div>
        <v-container justify-start pb-0>
            <v-layout
                v-bind="{
                    column: $vuetify.breakpoint.xsOnly,
                    row: $vuetify.breakpoint.smAndUp
                }"
                wrap
                align-content-start
                justify-start
            >
                <v-flex shrink>
                    <div class="title mb-2 mr-2">Seasons</div>
                </v-flex>
                <v-divider vertical class="hidden-xs-only mr-2"></v-divider>
                <v-flex align-self-start>
                    <v-breadcrumbs divider=">" style="display:inline; padding-left: 0;">
                        <v-breadcrumbs-item style to="/admin" v-bind:exact="exact">Administration</v-breadcrumbs-item>
                        <v-breadcrumbs-item style to="/admin/seasons" v-bind:exact="exact">Seasons</v-breadcrumbs-item>
                    </v-breadcrumbs>
                </v-flex>
            </v-layout>
            <v-divider></v-divider>
            <v-btn
                flat
                small
                color="primary"
                class="mb-3 mt-3"
                to="/admin/seasons/new"
                right
            >New Season</v-btn>
        </v-container>
        <v-container grid-list-md pt-0>
            <v-layout row wrap justify-start>
                <template v-for="season in seasons">
                    <v-flex xs12 sm6 md6 lg4>
                        <v-card>
                            <v-card-title>
                                <div class="subheading">{{ season.season }}</div>
                            </v-card-title>
                            <v-divider></v-divider>
                            <v-card-actions>
                                <!-- <v-btn flat small color="warning" right>Edit</v-btn> -->
                                <v-btn
                                    flat
                                    small
                                    color="error"
                                    v-on:click="issueDelete(season)"
                                >Delete</v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-flex>
                </template>
            </v-layout>
        </v-container>
    </div>
</template>

<script>
export default {
    name: 'AdminSeasons',
    data() {
        return {
            exact: true
        }
    },
    methods: {
        issueDelete(season) {
            this.$store.dispatch('deleteSeason', {
                season: season
            })
        }
    },
    computed: {
        seasons() {
            return this.$store.getters.getSortedSeasons
        }
    }
}
</script>

<style scoped></style>
